import { Navigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'

function getIsAdmin() {
	const token = localStorage.getItem('jwtToken')
	if (!token) return false
	try {
		return Boolean(jwtDecode(token)?.isAdmin)
	} catch {
		return false
	}
}

function AdminGate({ children }) {
	if (!getIsAdmin()) {
		return <Navigate to="/dashboard" replace />
	}
	return children
}

export default AdminGate
